import { memo } from 'react';

import Divider from '@mui/material/Divider';

export default memo(function ToolbarDivider() {
  return <Divider orientation="vertical" sx={{ my: '6px', mx: '2px', height: 'auto' }} />;
});
